import { render, staticRenderFns } from "./EditTaxInvoiceAddress.vue?vue&type=template&id=23936eba"
import script from "./EditTaxInvoiceAddress.vue?vue&type=script&lang=js"
export * from "./EditTaxInvoiceAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports